import React from 'react';

import { Box, Stack, TextField, Button, Typography, IconButton, List, ListItem, ListItemIcon, ListItemText, Container, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import Service from '../../../util/Service';

const NodeProcesso = React.forwardRef((props, ref) => {
// export default function NodeProcesso(props) {
    const { item, processo, tipo, task } = props;
    const [list, setList] = React.useState([]);
    const [categoria, setCategoria] = React.useState('');

    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            handleComplete();
          }
    }))   

    React.useEffect(() => {
        if (item && processo) {
            const t = processo.lstTask.find((i) => i.idTask === item.id);
            if (t) {
                setList(t.categorias)
            }
        }
    }, [])
    const handleComplete = () => {
        // const newCompleted = completed;
        // newCompleted[activeStep] = true;
        // setCompleted(newCompleted);
        // handleNext();
        const send = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,
            categorias: list,
            tipo: tipo,
        }
        Service.POST("/api/bpmn/salvarTaskDoProcesso", send).then(resp => {
            console.log(resp);
        }).catch(error => {
            console.error(error)
        })
    };
    const remove = (item) => {

        let arr = [];
        for (let x in list) {
            if (list[x] !== item) {
                arr.push(list[x])
            }
        }
        setList(arr);
    }

    return (
        <Container maxWidth="md" sx={{ mt: '40px' }}>
            <Typography>Indique o comportamento do processo</Typography>
            <Typography variant='body2' component='div'>
                <p>Tipos de comportamento</p>
                <ul>
                    <li><strong>On-line </strong>Processo responderá requisição HTTP "/api/bpmn/onLine/{processo.nome}"</li>
                    <li><strong>EventSource </strong>API para executar SSE (Server-Sent-Event envento enviado do servidor) em uma conexão persistente HTTP"/api/bpmn/onLine/{processo.nome}"</li>
                    <li><strong>backgroud </strong>Execuções em plano de fundo que executará de acordo com as defenições no Node de inicialização</li>
                </ul>
            </Typography>
            <Stack direction="row" spacing={1}>
                <FormControl variant="standard" sx={{ m: 1, minWidth:220, maxWidth: 400 }}>
                    <InputLabel id="demo-simple-select-standard-label">Categoria</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={categoria}
                        onChange={(e) => setCategoria(e.target.value)}
                        label="Tipo do processo"
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        <MenuItem value="online">On-line</MenuItem>
                        <MenuItem value="SSE">SSE (Server-Sent-Event)</MenuItem>
                        <MenuItem value='backgroud'>Execução em backgroud</MenuItem>
                    </Select>
                </FormControl>
                {/* <TextField id="tipo" label="Categoria" variant="standard" value={categoria} onChange={(e) => setCategoria(e.target.value)} /> */}
                <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={() => {

                    if (categoria && categoria.length > 0) {
                        let arr = [...list];
                        arr.push(categoria);
                        setList(arr);
                        setCategoria('');

                    }
                }}>
                    <AddIcon />
                </IconButton>
            </Stack>

            <List >
                {list && list.map((l, i) => (
                    <ListItem key={i}
                        secondaryAction={
                            <IconButton edge="end" aria-label="delete" onClick={() => remove(l)}>
                                <DeleteIcon />
                            </IconButton>
                        }
                    >
                        <ListItemText
                            primary={l}
                        />
                    </ListItem>
                ))}
            </List>

            {/* <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>

                <Button onClick={handleComplete}>
                    Salvar
                </Button>

            </Box> */}
        </Container>
    )
});

export default NodeProcesso;